import axios from '@/libs/api.request'
import config from '@/config'

const workFlowBaseUrl = config.baseWorkflowUrl + '/api/v1/'

export const getRoleApplicateFlow = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'role_applicate_flow/',
    params: params,
    traditional: true,
    method: 'get'
  })
}

export const createRoleApplicateFlow = (data) => {
  return axios.request({
    url: workFlowBaseUrl + 'role_applicate_flow/',
    data: data,
    method: 'post'
  })
}

export const detailRoleApplicateFlow = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'role_applicate_flow/' + id + '/',
    method: 'get'
  })
}

export const deleteRoleApplicateFlow = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'role_applicate_flow/' + id + '/',
    method: 'delete'
  })
}
